import type { IResult } from 'ua-parser-js'

import packageJson from '../../package.json'

import { AppError } from '@app/errors/AppError'

export class ApplicationAgent {
  private userAgent: IResult | null
  readonly device: string
  readonly os: string
  readonly sha?: string
  readonly identifier: string
  readonly agent: string

  constructor(data?: IResult) {
    this.userAgent = data ?? null

    this.device = !this.userAgent ? 'server' : `${this.formatted(this.userAgent?.device?.vendor)}/${this.formatted(this.userAgent?.device?.model)}`

    this.os = !this.userAgent ? this.getOs() : `${this.formatted(this.userAgent?.os?.name)}/${this.formatted(this.userAgent?.os?.version)}`

    this.sha = GIT_SHA

    this.identifier = 'ru.kidsout.www'

    this.agent = `${this.device} ${this.os} ${this.identifier}/${packageJson.version}`
  }

  private getOs() {
    // Only reached without a user agent, which is the server. Saying so keeps `os` out of the
    // client bundle, where it resolves to an empty object — and a browser that gets here was
    // built without the user agent it always has, which is worth hearing about.
    if (IS_BROWSER) throw new AppError('ApplicationAgent: no user agent to read the os from')

    const os: typeof import('os') = require('os')
    return `${this.formatted(os.platform())}/${this.formatted(os.release())}`
  }

  private formatted(value?: string) {
    return (value || 'unknown').replace(/\s+/g, '_')
  }
}
